module.exports = __webpack_public_path__ + "img/mob_about01.efa57dbc.png";